import TopBar from "./components/TopBar";
import Hero from "./components/Hero";
import Speakers from "./components/Speakers";
import About from "./components/About";
import Coundown from "./components/Countdown";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <TopBar />
      <Hero />
      <About />
      <Speakers />
      <Coundown />
      <Footer />
    </div>
  );
}

export default App;
